<template>
  <div class="common-header">
    <div v-if="loginLevel > 0">
      <CommonMenu />
    </div>
    <div v-else>
      <CommonPublic />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CommonMenu from './CommonMenu';
import CommonPublic from './CommonPublic';

export default {
  name: 'CommonHeader',
  components: { CommonMenu, CommonPublic },
  computed: {
    ...mapState({
      loginLevel: state => state.auth.level,
    }),
  },
};
</script>

<style scoped>
</style>
